import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import { TopNav, SiteFooter } from './SiteChrome';
import { useLanguage } from './LanguageContext';

const Services = () => {
  const { content } = useLanguage();

  return (
    <div className="services-page">
      <TopNav />

      {/* Main Content */}
      <main className="services-main">
        {/* Cosmic Particle Mask (Decorative) */}
        <div className="services-particle-mask"></div>

        <div className="services-header animate-fade-up">
          <h1 className="services-title">
            {content.services.title} <span className="title-highlight">{content.services.titleHighlight}</span>
          </h1>
          <p className="services-subtitle">
            {content.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-container">
          <div className="services-grid">
            {/* Card 1: Software Development */}
            <div className="service-card card-1 animate-scale-in delay-100">
              <div className="card-icon-wrapper">
                <div className="card-icon-glow"></div>
                <span aria-hidden="true" className="material-symbols-outlined card-icon">code</span>
              </div>
              <h3 className="card-title">{content.services.cards[0].title}</h3>
              <p className="card-text">{content.services.cards[0].text}</p>
              <Link className="card-link" to="/contact">
                {content.services.explore}
                <span aria-hidden="true" className="material-symbols-outlined card-link-icon">arrow_outward</span>
              </Link>
            </div>

            {/* Card 2: Digital Transformation */}
            <div className="service-card card-2 animate-scale-in delay-200">
              <div className="card-icon-wrapper">
                <div className="card-icon-glow"></div>
                <span aria-hidden="true" className="material-symbols-outlined card-icon">hub</span>
              </div>
              <h3 className="card-title">{content.services.cards[1].title}</h3>
              <p className="card-text">{content.services.cards[1].text}</p>
              <Link className="card-link" to="/contact">
                {content.services.explore}
                <span aria-hidden="true" className="material-symbols-outlined card-link-icon">arrow_outward</span>
              </Link>
            </div>

            {/* Card 3: IT Consulting */}
            <div className="service-card card-3 animate-scale-in delay-300">
              <div className="card-icon-wrapper">
                <div className="card-icon-glow"></div>
                <span aria-hidden="true" className="material-symbols-outlined card-icon">psychology</span>
              </div>
              <h3 className="card-title">{content.services.cards[2].title}</h3>
              <p className="card-text">{content.services.cards[2].text}</p>
              <Link className="card-link" to="/contact">
                {content.services.explore}
                <span aria-hidden="true" className="material-symbols-outlined card-link-icon">arrow_outward</span>
              </Link>
            </div>

            {/* Card 4: UI/UX Design */}
            <div className="service-card card-4 animate-scale-in delay-400">
              <div className="card-icon-wrapper">
                <div className="card-icon-glow"></div>
                <svg
                  aria-hidden="true"
                  className="card-icon card-icon-svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                </svg>
              </div>
              <h3 className="card-title">{content.services.cards[3].title}</h3>
              <p className="card-text">{content.services.cards[3].text}</p>
              <Link className="card-link" to="/contact">
                {content.services.explore}
                <span aria-hidden="true" className="material-symbols-outlined card-link-icon">arrow_outward</span>
              </Link>
            </div>

            {/* Card 5: Hardware Infrastructure */}
            <div className="service-card card-5 animate-scale-in delay-500">
              <div className="card-icon-wrapper">
                <div className="card-icon-glow"></div>
                <svg
                  aria-hidden="true"
                  className="card-icon card-icon-svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="6" y="6" width="12" height="12" rx="2"></rect>
                  <rect x="9" y="9" width="6" height="6" rx="1"></rect>
                  <path d="M9 2v2"></path>
                  <path d="M15 2v2"></path>
                  <path d="M9 20v2"></path>
                  <path d="M15 20v2"></path>
                  <path d="M2 9h2"></path>
                  <path d="M2 15h2"></path>
                  <path d="M20 9h2"></path>
                  <path d="M20 15h2"></path>
                </svg>
              </div>
              <h3 className="card-title">{content.services.cards[4].title}</h3>
              <p className="card-text">{content.services.cards[4].text}</p>
              <Link className="card-link" to="/contact">
                {content.services.explore}
                <span aria-hidden="true" className="material-symbols-outlined card-link-icon">arrow_outward</span>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default Services;
